const COMMON_TIP_PREFIX = "DE_TIP";

export const TIP_DETAIL_TEST_IDS = {
    DE_TIP_HEADER: `${COMMON_TIP_PREFIX}_HEADER`,
    DE_TIP_INFO_LINK: `${COMMON_TIP_PREFIX}_INFO_LINK`,
    DE_TIP_OPT_IN_CHECKBOX: `${COMMON_TIP_PREFIX}_OPT_IN_CHECKBOX`,
    DE_TIP_AMOUNT_VALUES: `${COMMON_TIP_PREFIX}_AMOUNT_VALUES`,
    DE_TIP_ENTER_TIP_AMOUNT: `${COMMON_TIP_PREFIX}_ENTER_TIP_AMOUNT`,
    DE_TIP_REMOVE_TIP_BUTTON: `${COMMON_TIP_PREFIX}_REMOVE_TIP_AMOUNT`,
};

export const NO_CONTACT_DELIVERY_OPT_IN_CHECKBOX = "NO_CONTACT_DELIVERY_OPT_IN_CHECKBOX";

export const APPLY_COUPON_TEST_ID = "APPLY_COUPON";
export const APPLIED_COUPON_TEST_ID = "APPLIED_COUPON";
export const COUPONLESS_SAVINGS_TEST_ID = "COUPONLESS_SAVINGS_APPLIED";
export const REMOVE_COUPON_BTN_TEST_ID = "REMOVE_COUPON_BTN";
export const COUPON_BTN_TEST_ID = "COUPON_BTN";

const DIRECT_APPLY_COUPON_PREFIX = "dacpr";

export const DIRECT_APPLY_COUPON_TEST_IDS = {
    COUPON_CODE: `${DIRECT_APPLY_COUPON_PREFIX}_coupon_code`,
    SUB_TEXT: `${DIRECT_APPLY_COUPON_PREFIX}_sub_text`,
    ADD_ITEM_CTA: `${DIRECT_APPLY_COUPON_PREFIX}_add_item_cta`,
    CONTAINER: `${DIRECT_APPLY_COUPON_PREFIX}_container`,
};
export const VIEW_MORE_COUPONS_TEST_ID = "VIEW_MORE_COUPONS";

export const APPLY_COUPON_MODAL_TEST_IDS = {
    CART_APPLY_COUPON_MODAL: "CART_APPLY_COUPON_MODAL",
    CART_APPLY_COUPON_MODAL_TEXT: "CART_APPLY_COUPON_MODAL_TEXT",
    CART_APPLY_COUPON_MODAL_CLOSE: "CART_APPLY_COUPON_MODAL_CLOSE",
    CART_APPLY_COUPON_DESCRIPTION: "CART_APPLY_COUPON_DESCRIPTION",
    CART_APPLY_COUPON_MODAL_PRIMARY_TEXT: "CART_APPLY_COUPON_MODAL_PRIMARY_TEXT",
    CART_APPLY_COUPON_MODAL_IMG: "CART_APPLY_COUPON_MODAL_IMG",
    CART_APPLY_COUPON_MODAL_CARD_FOOTER: "CART_APPLY_COUPON_MODAL_CARD_FOOTER",
    CART_APPLY_COUPON_MODAL_CARD_FOOTER_ICON: "CART_APPLY_COUPON_MODAL_CARD_FOOTER_ICON",
    CART_APPLY_COUPON_MODAL_CARD_FOOTER_TEXT: "CART_APPLY_COUPON_MODAL_CARD_FOOTER_TEXT",
    CART_APPLY_COUPON_MODAL_CARD_FOOTER_SUBTEXT: "CART_APPLY_COUPON_MODAL_CARD_FOOTER_SUBTEXT",
};

export const CART_MODAL_MAX_SAVINGS_TEST_IDS = {
    CART_MODAL_MAX_SAVINGS_CONTAINER: "CART_MODAL_MAX_SAVINGS_CONTAINER",
    CART_MODAL_MAX_SAVINGS_LOTTIE_CONTAINER: "CART_MODAL_MAX_SAVINGS_LOTTIE_CONTAINER",
    CART_MODAL_MAX_SAVINGS_LOTTIE_ANIMATION: "CART_MODAL_MAX_SAVINGS_LOTTIE_ANIMATION",
    CART_MODAL_MAX_SAVINGS_SCREEN_READER_TEXT: "CART_MODAL_MAX_SAVINGS_SCREEN_READER_TEXT",
    CART_MODAL_MAX_SAVINGS_PRIMARY_TEXT: "CART_MODAL_MAX_SAVINGS_PRIMARY_TEXT",
    CART_MODAL_MAX_SAVINGS_PRIMARY_SUBTEXT: "CART_MODAL_MAX_SAVINGS_PRIMARY_SUBTEXT",
    CART_MODAL_MAX_SAVINGS_SECONDARY_TEXT: "CART_MODAL_MAX_SAVINGS_SECONDARY_TEXT",
    CART_MODAL_MAX_SAVINGS_SECONDARY_SUBTEXT: "CART_MODAL_MAX_SAVINGS_SECONDARY_SUBTEXT",
    CART_MODAL_MAX_SAVINGS_CTA_TEXT: "CART_MODAL_MAX_SAVINGS_CTA_TEXT",
    CART_MODAL_MAX_SAVINGS_CLOSE: "CART_MODAL_MAX_SAVINGS_CLOSE",
    CART_MODAL_MAX_SAVINGS_PLUS_ICON: "CART_MODAL_MAX_SAVINGS_PLUS_ICON",
};

export const CROUTON_TEST_ID = "crouton-title";

const CROUTON_PREFIX = "CROUTON";

export const CROUTON = {
    ECO_SAVER_TOAST: `${CROUTON_PREFIX}_ECO_SAVER_TOAST`,
};
